import React, {
} from 'react';
import {
 Button, CardContent, CardHeader,
} from '@material-ui/core';
import {
  Props,
} from './types';

const SmartWidgetCard: React.FC<Props> = (props: Props) => {
  return (
    (
      <>
        <CardContent>
          This is smart widget the data will be retireved automatilcllay at mobile screens
        </CardContent>
      </>
    )
  );
};

export default SmartWidgetCard;

